import React from 'react'
import logo2 from '../images/logo2.png'
import { Link } from 'gatsby'

const Navbar = () => {

    return (
        <>
            <div className="nav-overlay">
                <div className="tooltip color-bg">Close Menu</div>
            </div>
            <div className="nav-holder">
                <a className="header-logo" href="index.html">
                    <img src={logo2} alt="PragICTS Logo" />
                </a>
                <div className="nav-title"><span>Menu</span></div>
                <div className="nav-inner-wrap">
                    <nav className="nav-inner sound-nav sliding-menu" id="menu">
                        <div className="sliding-menu-wrapper">
                            <ul className='menu-panel-root'>
                                <li>
                                    <Link to="/"  activeClassName="act-link">Home</Link>
                                </li>
                                <li>
                                    <Link to="/general"  activeClassName="act-link">General</Link>
                                </li>
                                <li>
                                    <Link to="/software-engineering"  activeClassName="act-link">Software Engineering</Link>
                                </li>
                                <li>
                                    <Link to="/digital-marketing"  activeClassName="act-link">Digital Marketing</Link>
                                </li>
                              
                                <li>
                                    <Link to="/itops"  activeClassName="act-link">IT Ops</Link>
                                </li>
                                <li>
                                    <Link to="/cloudops"  activeClassName="act-link">Cloud Ops</Link>
                                </li>
                                <li>
                                    <Link to="/cyber-security-ops"  activeClassName="act-link">Cyber Security Ops</Link>
                                </li>
                                 <li>
                                    <Link to="/ai"  activeClassName="act-link">AI</Link>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </>
    )
}

export default Navbar
